import { sizes } from '@bnnvara/breakpoints';
import * as StyleCard from '@bnnvara/cards/src/components/deprecated/SliderCard/styled';
import Slider from '@bnnvara/slider';
import * as StyleSlider from '@bnnvara/slider/src/components/Slider/styled';
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  background: #101010;
  margin: auto;
  width: 100%;
  z-index: 100;
  @media (min-width: ${sizes.xs}px) {
    transform: translateY(-50%);
    top: 50%;
  }
  @media (min-width: ${sizes.md}px) {
    top: 67%;
  }
  @media (min-width: ${sizes.lg}px) {
    top: 72.5%;
  }
`;

export const HeaderSlider = styled.div`
  display: flex;
  margin: 10px 16px 4px;
  justify-content: space-between;
`;

export const HideButton = styled.div`
  cursor: pointer;
`;

export const Title = styled.h4`
  margin: 0;
`;

export const SliderStyled = styled(Slider)`
  position: relative;
  overflow-x: visible;
  max-width: auto;
  padding: 12px 16px 16px;
  background: none;
  a {
    text-decoration: none;
  }
  h2 {
    font-size: 16px;
    line-height: 19px;
    margin-top: 0px;
    @media (max-width: ${sizes.xs}px) {
      font-size: 12px;
      line-height: 14px;
      color: #fff;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-top: auto;
    }
  }

  .slick-slider {
    bottom: 0;
    padding: 0;
  }

  @media (max-width: ${sizes.md}px) {
    ${StyleCard.CardIconBox} {
      width: 20px;
      height: 20px;
      svg {
        scale: 0.8;
      }
    }

    ${StyleSlider.Arrow} {
      display: flex;
      padding: 0;
      svg {
        width: 20px;
        height: 25px;
        position: relative;
      }
    }
    ${StyleSlider.PrevArrow} {
      svg {
        left: 1px;
      }
    }
    ${StyleSlider.NextArrow} {
      svg {
        right: 1px;
      }
    }
  }

  @media (max-width: ${sizes.xs}px) {
    .slick-slide a > div {
      height: 88px;
      flex-direction: row;
      & > div {
        height: auto;
      }
      & > div:first-child {
        height: 100%;
        position: absolute;
        &:before {
          position: absolute;
          bottom: 0;
          content: '';
          height: 48px;
          width: 100%;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            #000000 100%
          );
        }
      }
      & span {
        display: none;
      }
    }
  }

  @media (min-width: ${sizes.xs}px) {
    ${StyleCard.CardWrapper} {
      flex-direction: row;
    }

    ${StyleCard.CardImageContainer} {
      width: 50%;
      flex-shrink: 0;
    }
  }
`;
